module.exports = __webpack_public_path__ + "static/media/login.dc5eaac6.png";